import React, {useState, useEffect, useContext} from "react";

import { LinkService } from "../services";

const Context = React.createContext();

function compare(a, b) {
  if (a.displayOrder < b.displayOrder) {
    return -1;
  }
  if (b.displayOrder < a.displayOrder) {
    return 1;
  }
  return 0;
}

function setupLinksData(links, setFooterLinks, setResourceLinks) {
  const footerLinks = [];
  const resourceLinks = [];

  for (let i = 0; i < links.length; i++) {
    if (links[i].type === "FOOTER") {
      footerLinks.push(links[i]);
    } else if (links[i].type === "RESOURCE") {
      resourceLinks.push(links[i]);
    }
  }

  footerLinks.sort(compare);
  resourceLinks.sort(compare);

  setFooterLinks(footerLinks);
  setResourceLinks(resourceLinks);
}

export const LinkProvider = ({ children, locale }) => {
  const [resourceLinks, setResourceLinks] = useState([]);
  const [footerLinks, setFooterLinks] = useState([]);

  useEffect(() => {
    LinkService.getLinks(locale)
      .then((data) => {
        setupLinksData(data, setFooterLinks, setResourceLinks);
      })
      .catch((e) => {
        console.error("An error occurred when retrieving links", e);
      });
  }, [locale]);

  return (
    <Context.Provider value={{ resourceLinks, footerLinks }}>
      {children}
    </Context.Provider>
  );
};

export const LinksConsumer = Context.Consumer;
export const useLinksContext = () => useContext(Context);